import React, { useState, useEffect } from "react";
import type ColorPickerProps from "../../../types/ui/ColorPickerProps";

export const ColorPicker: React.FC<ColorPickerProps> = ({
  id,
  initialColor = "#ffb6c1",
  onSave,
  debounceMs = 800,
  classNames = "",
}) => {
  const [color, setColor] = useState<string>(initialColor);
  const [pendingColor, setPendingColor] = useState<string>(initialColor);

  useEffect(() => {
    if (!id) return;

    const timeout = setTimeout(() => {
      if (pendingColor !== color) {
        onSave(id, pendingColor);
        setColor(pendingColor);
      }
    }, debounceMs);

    return () => clearTimeout(timeout);
  }, [color, pendingColor, onSave, id, debounceMs]);

  return (
    <div
      className={`flex flex-col items-center justify-center rounded-full ${classNames}`}
    >
      <input
        type="color"
        value={pendingColor}
        onChange={(e) => setPendingColor(e.target.value)}
        className="w-8 h-8 cursor-pointer"
      />
    </div>
  );
};
